















import { Vue, Component, Prop } from "vue-property-decorator";

import LiveSvg from '../../../../assets/svg/live.svg';

import { Status } from "./Status";
import { Element } from "@api/models/Element";

@Component({
  components: { LiveSvg },
})
export default class SessionStatusBar extends Vue {

  @Prop({ required: true }) session: Element;
  @Prop({ default: false }) showInfoIcon: boolean;
  @Prop({ required: true, default: Status.empty }) currentStatus: Status;
  @Prop({ required: true, default: "" }) timeString: string;

  timer?: NodeJS.Timeout;
  passed = "";

  Status = Status;

  get isLive() {
    return this.currentStatus === Status.started || this.currentStatus === Status.endSoon
  }

  get showBar() {
    return this.currentStatus !== Status.empty
  }

  get hours() {
    return this.timeString.length > 5;
  }

  get manualControll() {
    return this.session.isManualControlled;
  }

  get isStarted() {
    return this.session.isStarted;
  }
}
